import { actionTypes } from './constants';
import { initialValues as filterMonitoring } from '../../components/fragments/SubMerchantAggregateFilter/fields';

const stateBuilder = (defaultData) => ({
  data: defaultData,
  loading: false,
  message: '',
  success: false,
  filter: {},
});

export const initialState = {
  local: {
    filter: filterMonitoring,
  },
  activity: stateBuilder({
    registered: 0,
    onboarding: 0,
    transaction: 0,
  }),
  regionalActivity: stateBuilder([]),
  countDataCompleted: stateBuilder({ total: 0 }),
  countOnboarding: stateBuilder({ total: 0 }),
  countTransaction: stateBuilder({ total: 0 }),
  countDataXOnBoard: stateBuilder({ total: 0 }),
  countTrxXOnBoard: stateBuilder({ total: 0 }),
};

export default function reducer(state = initialState, action) {
  const {
    type,
    data,
    loading,
    message = '',
    success = true,
    meta,
    // initial = true,
    filter,
    key,
    error
  } = action;

  switch (type) {
    case actionTypes.FAILED:
      return {
        ...state,
        [key]: {
          ...state[key],
          data: data || initialState[key].data,
          error: error,
          loading: false,
          message,
          success: false,
        },
      };
    case actionTypes.LOADING:
      return {
        ...state,
        [key]: {
          ...state[key],
          success: false,
          loading,
          message: '',
        },
      };
    case actionTypes.SUCCESS:
      return {
        ...state,
        [key]: {
          ...state[key],
          data: data,
          meta,
          loading: false,
          error: {},
          message,
          success,
        },
      };
    case actionTypes.FILTER:
      return {
        ...state,
        [key]: {
          ...state[key],
          filter,
        },
      };
    case actionTypes.MESSAGE:
      return {
        ...state,
        [key]: {
          ...state[key],
          success: false,
          loading: false,
          message,
        },
      };
    default:
      return state;
  }
}
